<template>
    <div>
        <transition-group name="fade" class="piece-list" tag="div">
        <piece v-for="(piece) in pieces"
               :key="piece.id"
               :piece="piece"
               :nonEdit="nonEdit"
               @delete="onDelete"
               @edit="onEdit"
               class="piece-list__item"
        />
        </transition-group>
    </div>
</template>

<script>
import piece from './piece/piece.component.vue';

export default {
  name: 'pieces-list',
  props: {
    pieces: Array,
    nonEdit: Boolean,
  },
  components: {
    piece,
  },
  methods: {
    onEdit(value) {
      this.$emit('edit', value);
    },
    onDelete(value) {
      this.$emit('delete', value);
    },
  },
};
</script>

<style scoped lang="scss">
    $itemGutter: 10;

    .piece-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 (-$itemGutter * 1px / 2) $itemGutter * 1px / 2;

        &__item {
            flex: 0 0 100%;
            max-width: calc(50% - #{$itemGutter * 1px});
            margin: 8px $itemGutter / 2 * 1px;

            @media screen and (max-width: 769px) {
                max-width: calc(100% - #{$itemGutter * 1px});
            }
        }
    }

    .site-form_group_label {
        width: 100%;
        margin: 0 $itemGutter / 2 * 1px 8px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
        transform: translate(0, -20px);
    }
</style>
